import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import useDlogLoginFunnel from '../../hooks/useDlogLoginFunnel';
import useContentForBuild from '../../hooks/useContentForBuild';
import { getFormattedText } from 'shared-modules';
import { FormattedText } from 'shared-types';
import FancyBorder from '../../components/fancyBorder/FancyBorder';
import usePreloadImages from '../../hooks/usePreloadImages';
import './upsell.sass';

export default function Upsell() {
  const navigate = useNavigate();
  const dlog = useDlogLoginFunnel();
  const [content] = useContentForBuild();
  const bg = 'https://prod.cdni.callofduty.com/prelogin/media/img/bg_cross-progression.jpg'; // loaded via css
  const deco = 'https://prod.cdni.callofduty.com/prelogin/media/img/crossprogression_operators.png';
  const imagesLoaded = usePreloadImages([bg, deco]);

  useEffect(() => {
    dlog({
      phase: 'Login_Upsell',
      action: 'Render',
    });
  }, [dlog]);

  const handleUpsell = (e: any) => {
    e.preventDefault();
    dlog({
      phase: 'Login_Upsell',
      action: 'Click',
      targets: 'Got_It',
    });
    navigate('/login');
  };

  return (
    <>
      <Helmet>
        <title>{content?.upsellTitle}</title>
      </Helmet>
      {content && imagesLoaded && (
        <div className="upsell">
          <div className="upsell__stripe">
            <div className="upsell__grid upsell__grid--col-2">
              <div className="upsell__deco">
                <img src={deco} alt="" />
              </div>
              <div>
                <h1>{content.upsellTitle1}</h1>
                <h2>{content.upsellTitle2}</h2>
                <div className="upsell__grid upsell__grid--col-3">
                  <div>
                    <FancyBorder className="upsell__border">
                      <div className="upsell__img">
                        <img src="https://prod.cdni.callofduty.com/prelogin/media/img/icon_lock.png" alt={content.upsellPanel2Title} />
                      </div>
                    </FancyBorder>
                    <h3 className="upsell__title">{content.upsellPanel1Title}</h3>
                  </div>
                  <div>
                    <FancyBorder className="upsell__border">
                      <div className="upsell__img">
                        <img src="https://prod.cdni.callofduty.com/prelogin/media/img/icon_rarity.png" alt={content.upsellPanel2Title} />
                      </div>
                    </FancyBorder>
                    <h3 className="upsell__title">{content.upsellPanel2Title}</h3>
                  </div>
                  <div>
                    <FancyBorder className="upsell__border">
                      <div className="upsell__img">
                        <img src="https://prod.cdni.callofduty.com/prelogin/media/img/icon_connect.png" alt={content.upsellPanel2Title} />
                      </div>
                    </FancyBorder>
                    <h3 className="upsell__title">{content.upsellPanel3Title}</h3>
                  </div>
                </div>
                <p className="upsell__desc">
                  {getFormattedText(content.upsellPanelDescription).map((item: FormattedText, i: number) => (
                    <span key={i} className={item.classNameTitle}>
                      {item.text}
                    </span>
                  ))}
                </p>
              </div>
            </div>
          </div>
          <button className="cta cta--wide" onClick={handleUpsell}>
            {content.upsellPanelCta}
          </button>
        </div>
      )}
    </>
  );
}
